import { render, staticRenderFns } from "./unionpayReceiptOrder.vue?vue&type=template&id=ddce1fac&scoped=true&"
import script from "./unionpayReceiptOrder.vue?vue&type=script&lang=js&"
export * from "./unionpayReceiptOrder.vue?vue&type=script&lang=js&"
import style0 from "./unionpayReceiptOrder.vue?vue&type=style&index=0&id=ddce1fac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddce1fac",
  null
  
)

export default component.exports